;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="a87bfb3b-e041-472e-8d46-7285dc06b52f",e._sentryDebugIdIdentifier="sentry-dbid-a87bfb3b-e041-472e-8d46-7285dc06b52f")}catch(e){}}();import React__default, { useContext } from 'react';
import 'react/jsx-runtime';
import CartFilled from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/CartFilled.js';
import { ButtonAnchor, CartButton, NumberBadge } from '@zooplus/ui-components';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import styles from './CartNavButton.module.scss.js';

const CART_URL = '/checkout/cart';
const navigateToCart = () => {
    window.location.assign(CART_URL);
};
const CartCounter = ({ cartCount }) => {
    return (React__default.createElement(React__default.Fragment, null, cartCount > 0 && (React__default.createElement(NumberBadge, { amount: cartCount, "data-zta": "header-cart-nav-counter", variant: "neutral", "aria-hidden": "true", className: styles.cartCounter }))));
};
const CartNavButton = () => {
    const { cart, translations } = useContext(AppContext);
    const cartCount = cart.summary.articleCount;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ButtonAnchor, { variant: "cart", className: styles.cartAnchorButton, href: CART_URL, "data-zta": "header-cart-nav-anchor", id: "header-cart-nav-anchor" },
            React__default.createElement(CartFilled, { "aria-hidden": "true" }),
            React__default.createElement("span", null, translations.get('shop.header.cart-nav.button.label')),
            React__default.createElement(CartCounter, { cartCount: cartCount })),
        React__default.createElement(CartButton, { withIcon: true, "data-zta": "header-cart-nav-button", className: styles.cartButton, size: "small", "aria-labelledby": "header-cart-nav-anchor", onClick: navigateToCart },
            React__default.createElement(CartCounter, { cartCount: cartCount }))));
};

export { CartNavButton };
//# sourceMappingURL=CartNavButton.js.map
